module.exports = __webpack_public_path__ + "static/img/kf_cloud_00010.4d60e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00010.jpg
// module id = 181
// module chunks = 1